module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('setting-title', {
    attrs: {
      "title": "代码管理"
    }
  }, [_c('div', {
    attrs: {
      "id": "backToReport"
    }
  }, [_vm._v("完成本页操作后可"), _c('router-link', {
    attrs: {
      "to": "/web/overview"
    }
  }, [_vm._v("查看分析")])], 1)]), _c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.tabViews), function(item) {
    return _c('li', {
      staticClass: "tab-item"
    }, [_c('div', {
      staticClass: "tabview-btn",
      class: {
        active: _vm.currentComp === item.comp
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeViewTo(item.comp)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  })), (_vm.currentComp === 'get-code') ? _c('get-code', {
    on: {
      "viewChange": function($event) {
        _vm.changeViewTo($event)
      }
    }
  }) : _vm._e(), (_vm.currentComp === 'install-code') ? _c('install-code') : _vm._e(), (_vm.currentComp === 'check-code') ? _c('check-code') : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e1292d62", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e1292d62!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/setting/gencode.vue
// module id = 804
// module chunks = 0